import React, { useEffect, useMemo, useState } from "react"
import {
  computeKyotoOpeningDisplay,
  getKyotoSimulatedNow,
} from "../utils/kyotoOpeningHours"

/** Öffnungszeiten-Karte auf der Startseite: aktueller Status + Wochenübersicht */
const OpeningHoursHomeSection = () => {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60_000)
    return () => clearInterval(id)
  }, [])

  const { isOpen, title, subtitle } = useMemo(
    () => computeKyotoOpeningDisplay(getKyotoSimulatedNow()),
    [tick]
  )

  return (
    <div className="px-2">
      <h4 className="text-2xl font-medium uppercase mb-3 text-black">
        Öffnungszeiten
      </h4>

      <div className="flex flex-col items-center gap-1 mb-4" aria-live="polite">
        <div className="flex items-center justify-center gap-2">
          <span
            className={`w-2 h-2 rounded-full shrink-0 ${
              isOpen
                ? "bg-green-600 animate-opening-status-pulse"
                : "bg-neutral-400"
            }`}
            aria-hidden
          />
          <span className="text-sm font-semibold text-black">{title}</span>
        </div>
        {subtitle ? (
          <p className="text-xs text-black/80 leading-snug max-w-[20rem] text-center px-1">
            {subtitle}
          </p>
        ) : null}
      </div>

      <div
        className="text-sm leading-relaxed text-black mx-auto inline-grid"
        style={{
          gridTemplateColumns: "auto auto",
          columnGap: "1.5rem",
          rowGap: "0.25rem",
        }}
      >
        <span className="text-right justify-self-end">Mo, Do–So</span>
        <span>16–22&nbsp;Uhr</span>
        <span className="text-right justify-self-end">Fr/Sa</span>
        <span>16–22:30&nbsp;Uhr</span>
        <span className="text-right justify-self-end">Di/Mi</span>
        <span>geschlossen</span>
      </div>
    </div>
  )
}

export default OpeningHoursHomeSection
